import { withI18n } from 'react-i18next';

import FoundInModels from './FoundInModels';

export const pureComponent = FoundInModels;
export default withI18n()(FoundInModels);
